//React
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
//Fetch
import axios from "axios";
//Context
import { useAuthContext } from "../../../Hooks/useAuthContext";
//Icons
import {
    faAdd,
    faArrowLeft,
    faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//Notifications
import { toast } from "react-toastify";
//Components
import { FloatingLabel, Form } from "react-bootstrap";
import MainContainer from "../../../Components/Containers/MainContainer";
import Loading from "../../../Components/Loading/Loading";

import FormControl from "../../../Components/Forms/FormControl";
import FormCheck from "../../../Components/Forms/FormCheck"

export default function ProjectReport() {
    const navigate = useNavigate();
    const { user, dispatch } = useAuthContext();


    const [codeOverviewloaded, setCodeOverviewLoaded] = useState(false);
    const [timesheetEntriesloaded, setTimesheetEntriesloaded] = useState(false);


    const [error, setError] = useState(false);
    const [fromDate, setFromDate] = useState(new Date());
    const [fromDate2, setFromDate2] = useState(new Date().toISOString("en-GB").split('T')[0]);
    const [toDate, setToDate] = useState(new Date());
    const [toDate2, setToDate2] = useState(new Date().toISOString("en-GB").split('T')[0]);

    const [timesheetStats, setTimesheetStats] = useState();
    const [timesheetEntries, setTimesheetEntries] = useState();
    const [totalHours, setTotalHours] = useState(0);
    
    function submitForm() {
        axios.post(
            `https://${process.env.REACT_APP_IP}/api/timesheets/report`,
            {
                fromDate,
                toDate
            },
            {
                headers: { Authorization: `bearer ${user.token}` },
            }
        ).then((response) => {
            console.log("Response: ", response.data)
            setTimesheetStats(response.data);
            setCodeOverviewLoaded(true);

            let total = 0;
            response.data.timesheetCodeTotals.map((entry) => {
                total += entry.hours
            });

            setTotalHours(total);
        });

    }

    function filterByCode(code) {
        axios.post(
            `https://${process.env.REACT_APP_IP}/api/timesheets/code/${code}`,
            {
                fromDate,
                toDate
            },
            {
                headers: { Authorization: `bearer ${user.token}` },
            }
        ).then((response) => {
            console.log("Response: ", response.data)
            setTimesheetEntries(response.data);

            setTimesheetEntriesloaded(true);

    
        });

    }


    
    const handleChangeFromDate = (e) => {
        console.log(e.target.value)
        var date = new Date(e.target.value)
        console.log(date)
        if (!isNaN(date) && date.getFullYear() > 2020) {
            console.log("date valid")
            setFromDate(date);

        }
        else {
            console.log("invalid date")
        }
        console.log(e.target.value)
    };

    const handleChangeToDate = (e) => {
        console.log(e.target.value)
        var date = new Date(e.target.value)
        console.log(date)
        if (!isNaN(date) && date.getFullYear() > 2020) {
            console.log("date valid")
            setToDate(date);

        }
        else {
            console.log("invalid date")
        }
        console.log(e.target.value)
    };

    return (

            <MainContainer>


                {/* Report Options Panel */}
                <div style={{ border: "1px solid #ccc", backgroundColor: "#eee" }} className="no-print">
                    <h4>Timesheet Code Report</h4>
                    <div className="row">
                        
                        <div className="col-3">
                            <Form.Group className={`mb-1  p-1`}>
                                <div className="form-floating">
                                    <input
                                        type="date"
                                        name="fromDate2"
                                        placeholder="From"
                                        defaultValue={fromDate2}
                                        onChange={handleChangeFromDate}
                                        className="form-control"
                                    />
                                    <label>
                                        From
                                    </label>
                                </div>
                            </Form.Group>
                        </div>
                        <div className="col-3">
                            <Form.Group className={`mb-1  p-1`}>
                                <div className="form-floating">
                                    <input
                                        type="date"
                                        name="toDate2"
                                        placeholder="To"
                                        defaultValue={toDate2}
                                        onChange={handleChangeToDate}
                                        className="form-control"
                                    />
                                    <label>
                                        To
                                    </label>
                                </div>
                            </Form.Group>
                        </div>

                        <div className="col-2">
                            <button type="submit" className="btn btn-primary" onClick={submitForm}>Generate</button>
                        </div>
                    </div>
                </div>


                {/* Results */}
                <div style={{ marginTop: 40 }}>

                {/* Timesheet Codes */}
                {codeOverviewloaded && (
                    <div className="col-5">
                        <div className="primaryShadow">
                            <div className="row ">
                                <div className="col-12">
                                    <h4>Timesheet Codes</h4>
                                </div>
                            </div>

                            <div className="row" style={{ marginBottom: 10 }}>
                                <div className="col-4">
                                    <strong>Timesheet Code</strong>
                                </div>
                                <div className="col-4 text-end">
                                    <strong>Hours</strong>
                        </div>
                        <div className="col-4 text-end">
                            <strong>&nbsp;</strong>
                        </div>
                            </div>


                            {timesheetStats && timesheetStats.timesheetCodeTotals.length > 0 ? timesheetStats.timesheetCodeTotals.map((entry) => (
                                <div className="row">
                                    <div className="col-4">
                                        {entry.timesheetCode}
                                    </div>
                                    <div className="col-4 text-end">
                                        {entry.hours}
                                    </div>
                                    <div className="col-4 text-end">
                                        <button type="button" class="btn btn-primary" onClick={() => {filterByCode(entry.timesheetCode)}}>View</button>
                                    </div>
                                </div>)) :
                                (<div className="row"><div className="col-12">No Timesheets Found</div></div>)
                            }

                            <div className="row" style={{ borderTop: "1px solid #000" }}>
                                <div className="col-4">
                                    <strong>Total</strong>
                                </div>
                                <div className="col-4 text-end">
                                    <strong>{totalHours}</strong>
                                </div>
                            </div>



                        </div>
                    </div>
                )}

                {/* Timesheet Entries for Code */}
                {timesheetEntriesloaded && (
                <div className="primaryShadow" style={{ marginTop: 20 }}>
                    <div className="row ">
                        <div className="col-12">
                            <h4>Timesheet Entries For Code { }</h4>
                        </div>
                    </div>
                {timesheetEntries && timesheetEntries.length > 0 ? (
                    <>
                    <div className="row">
                        <div className="col-2">
                            Date
                        </div>
                        <div className="col-6">
                            Task
                        </div>
                        <div className="col-1 text-end">
                            Hours
                        </div>
                        <div className="col-1 text-end">
                            Miles
                        </div>
                        <div className="col-1 text-end">
                            Expenses
                        </div>
                    </div>
                    {timesheetEntries.map((entry) => (
                        <div className="row">
                            <div className="col-2">
                                {new Date(entry.date).toLocaleDateString("en-GB")}
                            </div>
                            <div className="col-6">
                                {entry.task}
                            </div>
                            <div className="col-1 text-end">
                                {entry.hours}
                            </div>
                            <div className="col-1 text-end">
                                {entry.miles}
                            </div>
                            <div className="col-1 text-end">
                                {entry.expenses}
                            </div>
                        </div>
                    ))}
                    </>
                    ) : (<div className="row"><div className="col-12">No Timesheets Found</div></div>) }
                    </div>
                )}
            </div>

        </MainContainer>
    )
}
